import axios from "axios";
import {
  BrandMemberSegment,
  BrandMemberSegmentDraft,
} from "../models/brandMemberSegment";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const isDevelopment =
  API_BASE_URL === "" ||
  API_BASE_URL === "https://sit-api-crm.getzpay.com" ||
  API_BASE_URL === "https://sit-applepay.getzpay.com" ||
  API_BASE_URL === "https://staging-api.getzpay.com" ||
  API_BASE_URL.includes("local");

export const brandMemberSegmentApi = {
  getBrandMemberSegment: async (token: string, brandId: string) => {
    const endpoint = isDevelopment
      ? `${API_BASE_URL}/v1/RFM/GetBrandMemberSegment`
      : `${API_BASE_URL}/v1/RFM/GetBrandMemberSegmentRedshift`;
    return axios.post(
      endpoint,
      //`${API_BASE_URL}/v1/RFM/GetBrandMemberSegmentRedshift`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  listBrandMemberSegment: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/ListBrandMemberSegment`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  createOrUpdateBrandMemberSegment: async (
    token: string,
    brandId: string,
    brandMemberSegmentData: BrandMemberSegmentDraft
  ) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/CreateOrUpdateBrandMemberSegment`,
      { brandId, ...brandMemberSegmentData },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  BulkBrandMemberSegment: async (
    token: string,
    brandMemberSegmentData: BrandMemberSegment[]
  ) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/BulkBrandMemberSegment`,
      brandMemberSegmentData,
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  deleteBrandMemberSegment: async (token: string, id: number) => {
    return axios.delete(`${API_BASE_URL}/v1/RFM/DeleteBrandMemberSegment`, {
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
      data: { Id: id },
    });
  },
  deleteBrandMemberSegmentDetail: async (token: string, id: number) => {
    return axios.delete(
      `${API_BASE_URL}/v1/RFM/DeleteBrandMemberSegmentDetail`,
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
        data: { Id: id },
      }
    );
  },
  resetBrandMemberSegment: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/ResetBrandMemberSegment`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  GetDefaultBrandMemberSegment: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetDefaultBrandMemberSegment`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
